
import axios from 'axios'

export default {
    state: {
        lead: {
            api_token: '',
            dealer_id: '',
            date: '',
            hour: '',
            first_name: '',
            last_name: '',
            email: null,
            phone_number: null,
            registration_number: '',
            description: '',
            door_to_door: 0,
            replacement_car: '0',
            model_id: null,
            brand_id: 13,//BMW
            // additional
            brand_val: null,
            comment_val: null,
            services_val: [],
            visit_date_val: false,
            visit_hour_val: 1,
            additional_options_val: [],
            postcode_val: null,
            city_val: null,
            country_val: null,
            phone_number_additional_val: null,
            accept1_val: null,
            mileage: null,
            vin: null,
            model_id: null,
            replacement_car_val: null,
            // term preferences
            date_from: null,
            hour_from: null,
            hour_to: null,
            term_key: null,
            service_time: 0,//szacowany czas naprawy
            visit_hour_name: '', // nazwa pory dnia
            // replacement car
            replacement_car_id: null,
            // advisor
            advisor_id: null,
            repair: null,
            mechanic_id: null,
            mechanic_hour: null
        },
        leadToDescription: {
            brand_val: "Marka",
            model_id: "Model",
            vin: "Vin",
            mileage: "Przebieg",
            postcode_val: "Kod pocztowy",
            city_val: "Miasto",
            country_val: "Kraj",
            phone_number_additional_val: "Dodatkowy numer telefonu",
            accept1_val: "Zgoda RODO",
            additional_options_val: "Dodatkowe opcje",
            comment_val: "Komentarz",
            visit_date_val: "Szukał terminu od",
            visit_hour_name: "Pora dnia",
            service_time: "Szacowany czas naprawy",
            replacement_car_val: "Samochód zastępczy"
        },
        validation: {
            brand: true,
            service: false,
            visit: false,
            client: false,
            car: false
        },
        leadResponse: false
    },
    mutations: {
        setLead(state, payload) { state.lead = payload },
        setLeadResponse(state, payload) { state.leadResponse = payload },
        setValidation(state, payload) { state.validation = payload }
    },
    getters: {
        getLead: state => state.lead,
        getValidation: state => state.validation,
        getLeadResponse: state => state.leadResponse
    },
    actions: {
        async sendLead({ commit, state, rootState }) {
            const ready = await this._vm.$recaptchaLoaded();
            if (ready) {

                const token = await this._vm.$recaptcha('login');

                if (token) {

                    // szacowany czas naprawy
                    state.lead.service_time = state.lead.services_val.length;

                    let description = Object.keys(state.leadToDescription).map(k => {

                        let value = [null, false].includes(state.lead[k]) ? '-' : state.lead[k];

                        return state.leadToDescription[k] + ": " + value + "/\n";
                    });

                    description += "/\n Wybrane usługi serwisowe: " + state.lead.services_val.map(e => {
                        return rootState.definitions.services.find(s => s.val === e).name
                    })

                    state.lead.description += description;


                    var formData = new FormData()
                    Object.keys(state.lead).forEach((key) => {
                        formData.append(key, [null, false, ''].includes(state.lead[key]) ? '-' : state.lead[key])
                    });

                    formData.append('recaptcha_token', token);

                    var xmlHttp = new XMLHttpRequest()
                    xmlHttp.onreadystatechange = function () {
                        if (xmlHttp.readyState == 4 && xmlHttp.status == 200) {
                            let response = JSON.parse(xmlHttp.responseText);
                            commit('setLeadResponse', response)
                        }
                    }
                    xmlHttp.open('post', 'https://serwis.inchcape.pl/send')
                    xmlHttp.send(formData)

                }

            }

        }
    },
    namespaced: true
}